import { FETCH_LANDING_PAGE_FIELDS } from "../actions/types";

const INITIAL_STATE = {
  pageTitleText: "",
  necklaceTitleText: "",
  necklaceDescriptionText: "",
  ringDescriptionText: "",
  ringTitleText: "",
  necklaceImageURL: "",
  ringImageURL: "",
  ringImageExplodedURL: "",
  selectButtonText: "",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LANDING_PAGE_FIELDS:
      if (action.payload.includes && action.payload.items) {
        const necklaceImageID =
          action.payload.items[0].fields.necklaceImage.sys.id;
        const ringImageID = action.payload.items[0].fields.ringImage.sys.id;
        const ringImageExplodedID =
          action.payload.items[0].fields.ringImageExploded.sys.id;
        let necklaceURL = "";
        let ringURL = "";
        let ringExplodedURL = "";
        for (let i = 0; i < action.payload.includes.Asset.length; i++) {
          if (action.payload.includes.Asset[i].sys.id === necklaceImageID) {
            necklaceURL =
              "https://" +
              action.payload.includes.Asset[i].fields.file.url.substring(2);
          }
          if (action.payload.includes.Asset[i].sys.id === ringImageID) {
            ringURL =
              "https://" +
              action.payload.includes.Asset[i].fields.file.url.substring(2);
          }
          if (action.payload.includes.Asset[i].sys.id === ringImageExplodedID) {
            ringExplodedURL =
              "https://" +
              action.payload.includes.Asset[i].fields.file.url.substring(2);
          }
        }
        return {
          ...state,
          pageTitleText: action.payload.items[0].fields.pageTitleText,
          necklaceTitleText: action.payload.items[0].fields.necklaceTitleText,
          ringDescriptionText:
            action.payload.items[0].fields.ringDescriptionText,
          ringTitleText: action.payload.items[0].fields.ringTitleText,
          necklaceImageURL: necklaceURL,
          ringImageURL: ringURL,
          ringImageExplodedURL: ringExplodedURL,
          selectButtonText: action.payload.items[0].fields.selectButtonText,
          necklaceDescriptionText:
            action.payload.items[0].fields.necklaceDescriptionText,
        };
      }
      return state;
    default:
      return state;
  }
};
